// -----------------------------------------------------------------------
// <copyright file="GetAuthTokenPurpose.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export const GetAuthTokenPurpose = {
  SignInValidation: 'SignInValidation',
  SignInAndConsumerCategoryOptions: 'SignInAndConsumerCategoryOptions',
  ConsumerCategoryOptions: 'ConsumerCategoryOptions',
  ConsumerModalitiesPage: 'ConsumerModalitiesPage',
  ConsumerSubmitTicket: 'ConsumerSubmitTicket',
  GetSAFActionSchema: 'GetSAFActionSchema',
  ExecuteSAFAction: 'ExecuteSAFAction',
  SAFSignIn: 'SAFSignIn',
  SAFForceSignIn: 'SAFForceSignIn',
};
